import { getUserNetworks } from '@/api/user/userNetworkApi';
import { createQueryHook } from '@/lib/adapters/react-query-adapter';
import { QueryKeys } from '@/lib/constants/query-keys';
import { type UserNetworksResponse } from '@/schemas/userNetwork';

export const useUserNetworks = createQueryHook<UserNetworksResponse, Error, [QueryKeys.USER_NETWORKS]>(
  [QueryKeys.USER_NETWORKS],
  () => getUserNetworks()
);
